const isNotNull = (value) => {
    return value !== null;
};
const isNotUndefined = (value) => {
    return value !== undefined;
};
const isNeitherNullNorUndefined = (value) => {
    return value !== undefined && value !== null;
};
export { isNotNull, isNotUndefined, isNeitherNullNorUndefined };
//# sourceMappingURL=guard.js.map